export function parseAnalyticsFile(filelist) {
    return filelist.find(elem => elem.Key === 'analytics.csv');
}

export function parseFilelist(response) {
    //let regex = new RegExp(/^(QSFP|SFP|XFP).*/, 'gi');
    let keys = response.map((elem) => elem.Key);
    let sizes = response.map((elem) => elem.Size);
    let metadatas = response.map((elem) => elem.Metadata);
    let modifyTimes = response.map((elem) => elem.LastModified);
    let s_keys = keys.map((str) => str.split('/'));
    let treeObj = Object.create(null);

    for (let indx = 0; indx < s_keys.length; indx++) {
        for (let i = 0; i < s_keys[indx].length; i++) {
            if (i === 0) {
                let level_0 = s_keys[indx][i];
                if (level_0 === 'analytics.csv'||level_0 === 'success.html'||level_0 === 'testi.txt') {
                    continue;
                }
                treeObj[level_0] = Object.assign({}, treeObj[level_0]);
            } else if (i === 1) {
                let level_0 = s_keys[indx][i - 1];
                let level_1 = s_keys[indx][i];
                if (level_1 === '') {
                    continue;
                }
                treeObj[level_0][level_1] = Object.assign({}, treeObj[level_0][level_1]);
            } else if (i === 2) {
                let level_0 = s_keys[indx][i - 2];
                let level_1 = s_keys[indx][i - 1];
                let level_2 = s_keys[indx][i];
                if (level_2 === '') {
                    continue;
                }
                if (!Array.isArray(treeObj[level_0][level_1][level_2])) {
                    treeObj[level_0][level_1][level_2] = Object.assign(
                        {},
                        treeObj[level_0][level_1][level_2]
                    );
                }
            } else if (i === 3) {

                let level_0 = s_keys[indx][i - 3];
                let level_1 = s_keys[indx][i - 2];
                let level_2 = s_keys[indx][i - 1];

                if (
                    Array.isArray(
                        treeObj[level_0][level_1][level_2]
                    )
                ) {
                    if (s_keys[indx][i].length > 0) {
                        treeObj[level_0][level_1][level_2].push(
                            {
                                name: s_keys[indx][i],
                                size: sizes[indx],
                                metadata: metadatas[indx],
                                modified: modifyTimes[indx],
                            }
                        );
                    }
                } else {
                    treeObj[level_0][level_1][level_2] = [];
                    if (s_keys[indx][i].length > 0) {
                        treeObj[level_0][level_1][level_2].push(
                            {
                                name: s_keys[indx][i],
                                size: sizes[indx],
                                metadata: metadatas[indx],
                                modified: modifyTimes[indx],
                            }
                        );
                    }
                }
            }
        }
    }
    return treeObj;
}
